/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useState } from 'react';
import { useStyles } from '~src/hooks/useStyles';
import { styleFn } from './style';
import { Button, Input } from 'antd';
import { useIntl } from 'react-intl';

export const defaultAnswerValues = {
  title: '',
  description: '',
  answer: '',
};

export type AnswerFormValues = {
  title?: string;
  description?: string;
  answer: string;
};

type AnswerQuickFormProps = {
  onAnswer?: (answer: AnswerFormValues) => Promise<unknown>;
  onCancelForm?: () => void;
};

const AnswerQuickForm: React.FC<AnswerQuickFormProps> = ({
  onAnswer,
  onCancelForm,
}) => {
  const intl = useIntl();
  const styles = useStyles(styleFn);

  const [answerFormData, setAnswerFormData] = useState<AnswerFormValues>(
    defaultAnswerValues
  );

  const handleSendAnswer = async () => {
    await onAnswer?.(answerFormData);
    onCancelForm?.();
    setAnswerFormData(defaultAnswerValues);
  };

  const handleClose = () => {
    onCancelForm?.();
    setAnswerFormData(defaultAnswerValues);
  };

  return (
    <div css={styles.formContainer}>
      <Input
        placeholder={intl.formatMessage({ id: 'answer' })}
        value={answerFormData.title}
        onChange={(e) =>
          setAnswerFormData((prev) => ({ ...prev, title: e.target.value }))
        }
      />
      <div css={styles.buttonsBlock}>
        <Button css={styles.leftButton} onClick={handleClose}>
          Cancel
        </Button>
        <Button type="primary" onClick={handleSendAnswer}>
          Send
        </Button>
      </div>
    </div>
  );
};

export default AnswerQuickForm;
